import { Div, Header } from "@grassrootly/rn-core";
import { ScreenLayoutProps } from "./ScreenLayout.types";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { StatusBar } from "expo-status-bar";
import { Platform } from "react-native";

export default function ScreenLayout({ children, header = false, footer = false }: ScreenLayoutProps) {
  const insents = useSafeAreaInsets();
  return (
    <Div classNames={["flex1", "minH-{100%}"]}>
      <StatusBar style="light" />
      {header ? <Header {...header} /> : null}
      <Div classNames={["flex1", "minH-{100%}", "bgNeutralDarkerDark", "justifyContentCenter"]}>
        <Div
          classNames={[
            "flex1",
            "maxW-{920}",
            "w-{100%}",
            "mr-{auto}",
            "ml-{auto}",
            `pr-{${insents.right + 16}}`,
            `pl-{${insents.left + 16}}`,
            footer ? "pb-{16}" : `pb-{${insents.bottom + 16}}`,
            header
              ? `pt-{${16 + (Platform.OS === "web" ? 65 : 0)}}`
              : `pt-{${insents.top + 16 + (Platform.OS === "web" ? 65 : 0)}}`,
          ]}
        >
          {children}
        </Div>
      </Div>
    </Div>
  );
}
